import React, { useContext, useEffect } from 'react';
import FlexColumn from '../components/shared/FlexColumn';
import { API } from '../utils/API';
import { apiConfig } from '../utils/apiConfig';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import UserContext from '../context/UserContext';
import DataTable from '../components/shared/DataTable';

export default function Permissions({ token }) {
  const { role } = useContext(UserContext);
  const isAdmin = role === 'admin';
  const [allAdmins, setAllAdmins] = React.useState([]);
  const [body, setBody] = React.useState({
    mail: '',
    password: '',
    role: 'admin',
  });

  const handleChangeBody = (setter, value) => {
    setBody((prev) => ({ ...prev, [setter]: value }));
  };

  const fetchAdmins = async () => {
    const res = await API(apiConfig.admin.getAllAdmins, 'POST');
    if (res.status) {
      setAllAdmins(res.users);
    }
  };

  const handleGivePerms = async () => {
    const res = await API(apiConfig.admin.insertUser, 'POST', body);
    if (res.status) {
      alert('משתמש הוסף בהצלחה');
      setBody({
        mail: '',
        password: '',
        role: 'admin',
      });
      fetchAdmins();
    }
  };

  useEffect(() => {
    fetchAdmins();
  }, []);

  return (
    <FlexColumn>
      {isAdmin && (
        <>
          <h1>הרשאות</h1>
          <h3>דוא״ל</h3>
          <input style={styles.input} value={body.mail} onChange={(e) => handleChangeBody('mail', e.target.value)} />
          <h3>סיסמא</h3>
          <input
            style={styles.input}
            value={body.password}
            onChange={(e) => handleChangeBody('password', e.target.value)}
          />
          <h3>סוג הרשאה</h3>
          <select style={styles.select} value={body.role} onChange={(e) => handleChangeBody('role', e.target.value)}>
            <option value="admin">הרשאות אדמין מלאות</option>
            <option value="view-only">צפייה בלבד</option>
          </select>
          <button style={styles.button} onClick={handleGivePerms}>
            שמירה
          </button>
          <div style={{ height: 50 }} />
        </>
      )}

      <DataTable
        columns={['דוא״ל', 'סוג הרשאה']}
        data={allAdmins}
        loading={false}
        renderRow={(user, index) => (
          <TableRow key={index}>
            <TableCell>
              <Typography style={styles.inline}>{user.mail}</Typography>{' '}
            </TableCell>
            <TableCell>
              <Typography style={styles.inline}>{user.role}</Typography>{' '}
            </TableCell>
          </TableRow>
        )}
      />

      <div style={{ height: 100 }} />
    </FlexColumn>
  );
}

const styles = {
  input: {
    padding: 10,
    fontSize: 15,
    border: '1px solid #ccc',
    borderRadius: 4,
  },
  select: {
    width: 200,
    height: 30,
    fontSize: 20,
    margin: 0,
    padding: 0,
    textAlign: 'center',
  },
  button: {
    backgroundColor: '#8f3cc0',
    color: '#fff',
    padding: '12px 20px',
    borderRadius: 24,
    border: 'none',
    fontWeight: 600,
    fontSize: 16,
    cursor: 'pointer',
    marginTop: 20,
  },
  inline: {
    textAlign: 'right',
  },
};
